import React from "react";
import Button from "../Button";
export default props => <Button as="text" {...props}>
    <i className={`fas fa-${props.icon} ${props.className} mx-1`} />
</Button>


// WEBPACK FOOTER //
// ./src/_components/IconButton/index.jsx